"use strict";
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ILCalendarNavigator = void 0;
var material_1 = require("@mui/material");
var react_1 = __importDefault(require("react"));
var providers_1 = require("../../providers");
var il_button_common_1 = require("../il-button/il-button.common");
function ILCalendarNavigator(_a) {
    var disabled = _a.disabled, children = _a.children, props = __rest(_a, ["disabled", "children"]);
    var classes = 'il-calendar-navigator ' + props.className;
    var ctx = react_1.default.useContext(providers_1.ILCalendarContext);
    if (!ctx || !(ctx === null || ctx === void 0 ? void 0 : ctx.selectedDate)) {
        throw new Error("Must be inside 'ILCalendarProvider'");
    }
    return (react_1.default.createElement(material_1.Grid, { className: classes, container: true, item: true, direction: "row", wrap: "nowrap", spacing: 3 },
        react_1.default.createElement(il_button_common_1.LeftButton, { disabled: disabled, onClick: function () { return ctx.decreaseDate(); } }),
        react_1.default.createElement(il_button_common_1.RightButton, { disabled: disabled, onClick: function () { return ctx.increaseDate(); } }),
        children));
}
exports.ILCalendarNavigator = ILCalendarNavigator;
